export enum Role {
  Company = "Empresas",
  Admin = "Admin",
  Doctor = "Doctor",
  Paciente = "Paciente",
  Representantes = "Representantes"
}
